import { Injectable } from '@angular/core';
import { AgentService, AgentInfo } from '../modules/agent/agent.service';
import { Router } from '@angular/router';
import { MembersPhotoTrackingService } from './members-photo-tracking.service';


@Injectable({
  providedIn: 'root'
})
export class AgentInfoProvider {
  private agentInfo: AgentInfo;
  private originalAgentInfo : AgentInfo;
  constructor(private agent_service: AgentService) { }
  
  public loadAgentLoginData() {
    return this.agent_service.loadData().toPromise().then(res => {
      this.agentInfo = new AgentInfo(res.element);
      this.originalAgentInfo = new AgentInfo(res.element);
      console.log('loading data');
    });
  }

  public loadAgentInfoData() {
    return this.agent_service.loadData().toPromise().then(res => {
      this.agentInfo = new AgentInfo(res.element);
      console.log('loading data');
    });
  }

  public get_agent_info() {
    return this.agentInfo;
  }
  public get_logged_info() {
    return this.originalAgentInfo;
  }
}
